import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=39ae74de"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductsGrid.vue?vue&type=style&index=0&id=39ae74de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports